import format from 'date-fns/format'
import locale from 'date-fns/locale/nb'
import isToday from 'date-fns/is_today'

import { IScheduleMatch, IResult } from '../../../types'

const HOUR = 1000 * 60 * 60

export function groupMatchesByDate(matches: IScheduleMatch[]) {
  const groupMap = matches.reduce((curr, match) => {
    const d = format(match.startDate, 'YYYY-MM-DD')

    if (!curr[d]) {
      curr[d] = []
    }

    curr[d].push(match)

    return curr
  }, {})

  return Object.keys(groupMap).map(date => {
    return {
      date: new Date(date),
      matches: groupMap[date]
    }
  })
}

export function formatDate(d: Date) {
  if (isToday(d)) {
    return 'I dag'
  }

  return format(d, 'D.M', { locale })
}

export function getMatchTimestamps(matches: IScheduleMatch[]) {
  const now = Date.now()

  return matches.map(m => {
    const t =
      typeof m.startDate === 'object'
        ? m.startDate.getTime()
        : Date.parse(m.startDate)
    return { id: m.id, status: m.status, delta: t - now }
  })
}

export function getNextMatchId(matches: IScheduleMatch[]): string | null {
  const matchTimestamps = getMatchTimestamps(matches)
  const nextMatchTimestamps = matchTimestamps.filter((m, idx) => {
    const nextMatch = matchTimestamps[idx + 1]

    if (!nextMatch) {
      return true
    }

    if (m.status === 'Pågår') {
      return true
    }

    if (
      nextMatch &&
      (m.status === 'Slutt' && nextMatch.status !== 'Slutt') &&
      nextMatch.delta > HOUR
    ) {
      return true
    }

    return m.delta >= 0
  })

  if (nextMatchTimestamps.length) {
    return nextMatchTimestamps[0].id
  }

  return null
}

export function formatResult(result: IResult): string {
  const { home, away } = result
  return `${home} – ${away}`
}
